import React from "react";
import { FiBox, FiFileText, FiKey } from "react-icons/fi";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function ContractorAppIcons() {
  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const services = [
    {
      id: 1,
      name: "Move-In/Out",
      icon: <FiBox size={24} />,
      description: "Manage tenant moving processes",
      url: "/move-in-out",
    },
    {
      id: 2,
      name: "Work Permit",
      icon: <FiFileText size={24} />,
      description: "Request construction approvals",
      url: "/work-permit",
    },
    {
      id: 3,
      name: "Gate Pass",
      icon: <FiKey size={24} />,
      description: "Request for Gate Pass for Materials and Equipment",
      url: "/gate-pass",
    },
  ];

  return (
    <div className="p-4 mb-6">
      <h2 className="text-lg font-semibold mb-4 text-[#363062]">Services</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {services.map((service) => (
          <motion.div
            onClick={() => handleNavigate(service.url)}
            key={service.id}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="bg-white rounded-lg p-4 shadow-md border border-gray-100 cursor-pointer"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#363062] text-white mb-3">
                {service.icon}
              </div>
              <h3 className="font-medium text-[#363062]">{service.name}</h3>
              <p className="text-[10px] text-gray-500 mt-1">
                {service.description}
              </p>
              <div className="mt-3 px-3 py-1 bg-[#8FCD00] text-white text-xs rounded-full">
                Access
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default ContractorAppIcons;
